import type { OverlayRegistrationProps } from '@/app/components/overlays/core/types';

/**
 * Generates a unique registry key by combining the overlayKey and optional instanceId.
 *
 * @param props - Overlay registration options including key and optional instanceId
 * @returns A unique string like "DRAWER_RIGHT__gallery-item-1"
 */
export const getOverlayRegistryKey = (
  props: OverlayRegistrationProps
): string => {
  const { overlayKey, instanceId } = props;
  return instanceId ? `${overlayKey}__${instanceId}` : overlayKey;
};
